// Action Types
const TRANSITION_CAMPAIGN_MODAL = 'TRANSITION_CAMPAIGN_MODAL';

// States
export const CAMPAIGN_MODAL_ENTRY = 'CAMPAIGN_MODAL_ENTRY';
export const CAMPAIGN_MODAL_RULE = 'CAMPAIGN_MODAL_RULE';
export const CAMPAIGN_MODAL_SUCCEED = 'CAMPAIGN_MODAL_SUCCEED';
export const CAMPAIGN_MODAL_WAYOUT = 'CAMPAIGN_MODAL_WAYOUT';
export const CAMPAIGN_MODAL_CLOSED = 'CAMPAIGN_MODAL_CLOSED';

const allStates = Object.freeze([
  CAMPAIGN_MODAL_ENTRY,
  CAMPAIGN_MODAL_RULE,
  CAMPAIGN_MODAL_SUCCEED,
  CAMPAIGN_MODAL_WAYOUT,
  CAMPAIGN_MODAL_CLOSED,
]);

// Action Creators
export function openCampaignEntryModal() {
  return {
    type: TRANSITION_CAMPAIGN_MODAL,
    payload: CAMPAIGN_MODAL_ENTRY,
  };
}

export function showCampaignRuleModal() {
  return {
    type: TRANSITION_CAMPAIGN_MODAL,
    payload: CAMPAIGN_MODAL_RULE,
  };
}

export function showCampaignSucceedModal() {
  return {
    type: TRANSITION_CAMPAIGN_MODAL,
    payload: CAMPAIGN_MODAL_SUCCEED,
  };
}

export function showCampaignWayoutModal() {
  return {
    type: TRANSITION_CAMPAIGN_MODAL,
    payload: CAMPAIGN_MODAL_WAYOUT,
  };
}

export function closeCampaignModal() {
  return {
    type: TRANSITION_CAMPAIGN_MODAL,
    payload: CAMPAIGN_MODAL_CLOSED,
  };
}

// Reducer
export default function reducer(state = CAMPAIGN_MODAL_CLOSED, action) {
  return action.type === TRANSITION_CAMPAIGN_MODAL && allStates.includes(action.payload) ? action.payload : state;
}
